import type { AxiosError } from 'axios'

export type ApiErrorInfo = {
  status: number | null
  message: string
}

/**
 * Extracts a human-friendly error message from Axios errors
 */
export function extractApiError(error: unknown): ApiErrorInfo {
  const fallback = 'Etwas ist schiefgelaufen. Bitte erneut versuchen.'

  const err = error as AxiosError<any>
  const status = err?.response?.status ?? null
  const data = err?.response?.data

  let message = (typeof data?.error === 'string' && data.error) || (typeof data?.message === 'string' && data.message) || (typeof err?.message === 'string' && err.message) || fallback

  // Status-based friendly overrides
  if (status === 401 || status === 419) {
    message = 'Bitte erneut anmelden.'
  } else if (status === 403) {
    message = 'Keine Berechtigung für diese Aktion.'
  } else if (status === 404) {
    message = message || 'Nicht gefunden.'
  } else if (status === 422) {
    message = message || 'Ungültige Eingabe.'
  } else if (status && status >= 500) {
    message = 'Serverfehler. Bitte später erneut versuchen.'
  }

  return { status, message }
}

/**
 * 404 during DELETE is expected (already deleted / idempotent)
 */
export function isIgnorableDelete404(error: unknown): boolean {
  const err = error as AxiosError
  return err?.response?.status === 404
}
